import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    submit: 'Finish',
    subtitle: 'It will be executed once the request is approved.',
    title: 'Your request has been sent to an admin',
  },
  fr: {
    submit: 'Terminer',
    subtitle: 'Votre virement sera traité une fois la demande approuvée.',
    title: 'Votre demande a bien été envoyée à un·e admin du compte',
  },
} as const);

export default locales;
